import { render, staticRenderFns } from "./InvolvementForm.vue?vue&type=template&id=1ea1d5a5"
import script from "./InvolvementForm.vue?vue&type=script&lang=js"
export * from "./InvolvementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports